<section>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="modal fade" id="selectpg-popup" tabindex="-1" aria-labelledby="exampleModalLabel"
                        aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body mdltp-txtcont">
                                    <h5>Change Password using Existing Credential</h5>
                                    <form [formGroup]="resetPasswordWithExistingPasswordForm">
                                        <div class="my-4">
                                            <label for="currentPassword" class="form-label">Current Password</label>
                                            <input type="password" class="form-control" id="currentPassword"
                                                formControlName="oldPassword"
                                                [ngClass]="{ 'is-invalid':  f['oldPassword'].errors && (f['oldPassword'].touched)}">
                                            <app-validation field="oldPassword"
                                                [form]="resetPasswordWithExistingPasswordForm"
                                                [error]="{required:'This is a mandatory field'}"></app-validation>
                                        </div>
                                        <div class="my-4">
                                            <label for="newPassword" class="form-label">New Password</label>
                                            <app-password-input [isInValid]="f[NEW_PASSWORD].errors && (f[NEW_PASSWORD].touched)"
                                                (passwordChange)="handleNewPasswordChange($event)"></app-password-input>
                                            <app-validation [field]="NEW_PASSWORD"
                                                [form]="resetPasswordWithExistingPasswordForm"
                                                [error]="{required:'This is a mandatory field', invalidPassword:'Password length should be equal or greater than 8, and should contain 1 Capital letter, 1 small letter, 1 number and 1 special character'}"></app-validation>
                                        </div>
                                        <div class="my-4">
                                            <label for="confirmPassword" class="form-label">Confirm Password</label>
                                            <app-password-input [isInValid]="f[CONFIRM_PASSWORD].errors && (f[CONFIRM_PASSWORD].touched)"
                                                (passwordChange)="handleConfirmPasswordChange($event)"></app-password-input>
                                            <app-validation [field]="CONFIRM_PASSWORD"
                                                [form]="resetPasswordWithExistingPasswordForm"
                                                [error]="{required:'This is a mandatory field', passwordMismatch: 'New Password and Confirm Password not matching'}"></app-validation>
                                        </div>
                                        <div class="btnpopdv text-center">
                                            <button type="button" class="btn-actvtytp"
                                                [disabled]="resetPasswordWithExistingPasswordForm?.invalid"
                                                (click)='updatePassword()'>UPDATE</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>